<template>
  <section>
    <div class="w-100 d-flex justify-content-end">
      <button class="btn btn-link mt-3" @click="dialogRegisterVisible = true">{{ $t('sidebar.addStudent') }}</button>
    </div>
    <div class="row my-4">
      <div v-if="Object.keys(students).length === 0" class="col-md-12 list-empty">
        <div class="alert alert-info" role="alert">
          {{ $t('children.notUserRegistered') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div v-for="student in students" :key="student.id" class="col-sm-12">
        <StudentItem :student="student" />
        
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogRegisterVisible"
      top="1vh"
      :before-close="onDialogRegisterVisible"
      :destroy-on-close="true"
    >
      <RegisterStudent />
    </el-dialog>
    <UserNotification/>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import StudentItem from './components/StudentItem.vue';
import RegisterStudent from './../signup/student/index';
import UserNotification from '@/views/UserNotification.vue';

export default {
  name: 'StudentList',
  components: {
    StudentItem,
    RegisterStudent,
    UserNotification,
  },
  data() {
    return {
      students: [],
      dialogRegisterVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/authenticatedUser',
    }),
  },
  created() {
    this.fetchStudents();
  },
  methods: {
    onDialogRegisterVisible() {
      this.dialogRegisterVisible = false;
    },
    fetchStudents() {
      this.$store.commit('app/START_PROCESSING');
      this.$httpMain
        .post(`get-all-user-by-rol`, {
          type_user: '1',
          tutor_id: this.user.id,
        })
        .then(res => {
          if (res.data) {
            this.students = res.data;
          }
        })
        .catch(() => {
          this.students = [];
        })
        .finally(() => {
          this.$store.commit('app/STOP_PROCESSING');
        });
    },
  },
};
</script>
<style lang="sass" scoped>
.list-empty
  max-width: 1200px
  margin: 0 auto
</style>
